
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from 'next/router';
import useLocale from 'next-translate/useTranslation';
import React from 'react';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import CallToAction from '@/components/CallToAction';
import FaqTranscription from '@/components/FaqTranscription';
import FeaturedLogos from '@/components/FeaturedLogos';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import LogosCloud from '@/components/LogosCloud';
import SecurityCompliance from '@/components/SecurityCompliance';
import Seo from '@/components/Seo';
import SupportedFormats from '@/components/SupportedFormats';
import Testimonials from '@/components/Testimonials';
import ThreeStepsProcess from '@/components/ThreeStepsProcess';
import TranscriptionFeaturesSimple from '@/components/TranscriptionFeaturesSimple';
import TranscriptionStats from '@/components/TranscriptionStats';
import LanguageSpeechToTextHero from '@/components/ai-transcription/LanguageSpeechToTextHero';
// Language configuration matching TranscriptionLanguages.tsx
export const transcriptionLanguages = [
    { name: 'Arabic', flag: '🇸🇦', slug: 'arabic' },
    { name: 'Bulgarian', flag: '🇧🇬', slug: 'bulgarian' },
    { name: 'Chinese', flag: '🇨🇳', slug: 'chinese' },
    { name: 'Croatian', flag: '🇭🇷', slug: 'croatian' },
    { name: 'Czech', flag: '🇨🇿', slug: 'czech' },
    { name: 'Danish', flag: '🇩🇰', slug: 'danish' },
    { name: 'Dutch', flag: '🇳🇱', slug: 'dutch' },
    { name: 'English', flag: '🇬🇧', slug: 'english' },
    { name: 'Estonian', flag: '🇪🇪', slug: 'estonian' },
    { name: 'Filipino', flag: '🇵🇭', slug: 'filipino' },
    { name: 'Finnish', flag: '🇫🇮', slug: 'finnish' },
    { name: 'French', flag: '🇫🇷', slug: 'french' },
    { name: 'German', flag: '🇩🇪', slug: 'german' },
    { name: 'Greek', flag: '🇬🇷', slug: 'greek' },
    { name: 'Hebrew', flag: '🇮🇱', slug: 'hebrew' },
    { name: 'Hindi', flag: '🇮🇳', slug: 'hindi' },
    { name: 'Hungarian', flag: '🇭🇺', slug: 'hungarian' },
    { name: 'Icelandic', flag: '🇮🇸', slug: 'icelandic' },
    { name: 'Indonesian', flag: '🇮🇩', slug: 'indonesian' },
    { name: 'Italian', flag: '🇮🇹', slug: 'italian' },
    { name: 'Japanese', flag: '🇯🇵', slug: 'japanese' },
    { name: 'Kazakh', flag: '🇰🇿', slug: 'kazakh' },
    { name: 'Korean', flag: '🇰🇷', slug: 'korean' },
    { name: 'Latvian', flag: '🇱🇻', slug: 'latvian' },
    { name: 'Lithuanian', flag: '🇱🇹', slug: 'lithuanian' },
    { name: 'Macedonian', flag: '🇲🇰', slug: 'macedonian' },
    { name: 'Malay', flag: '🇲🇾', slug: 'malay' },
    { name: 'Norwegian', flag: '🇳🇴', slug: 'norwegian' },
    { name: 'Polish', flag: '🇵🇱', slug: 'polish' },
    { name: 'Portuguese', flag: '🇵🇹', slug: 'portuguese' },
    { name: 'Romanian', flag: '🇷🇴', slug: 'romanian' },
    { name: 'Russian', flag: '🇷🇺', slug: 'russian' },
    { name: 'Serbian', flag: '🇷🇸', slug: 'serbian' },
    { name: 'Slovak', flag: '🇸🇰', slug: 'slovak' },
    { name: 'Slovenian', flag: '🇸🇮', slug: 'slovenian' },
    { name: 'Spanish', flag: '🇪🇸', slug: 'spanish' },
    { name: 'Swedish', flag: '🇸🇪', slug: 'swedish' },
    { name: 'Tamil', flag: '🇮🇳', slug: 'tamil' },
    { name: 'Thai', flag: '🇹🇭', slug: 'thai' },
    { name: 'Turkish', flag: '🇹🇷', slug: 'turkish' },
    { name: 'Ukrainian', flag: '🇺🇦', slug: 'ukrainian' },
    { name: 'Vietnamese', flag: '🇻🇳', slug: 'vietnamese' },
];
const LanguageSpeechToText = () => {
    const { t, lang } = useLocale('ai-transcription');
    const router = useRouter();
    const { language } = router.query;
    if (typeof language !== 'string') {
        return null; // or handle the error/loading state
    }
    // Find the language object
    const languageObj = transcriptionLanguages.find((lang) => lang.slug === language.toLowerCase());
    if (!languageObj) {
        return null;
    }
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t(languageObj.name) +
            ' ' +
            t('Speech to Text') +
            ' – ' +
            t('Transcribe') +
            ' ' +
            t('Audio Online')} description={t('Transcribe') +
            ' ' +
            t(languageObj.name) +
            ' ' +
            t('audio to text online with our AI-powered transcription service. High accuracy') +
            ' ' +
            t(languageObj.name) +
            ' ' +
            t('speech recognition, speaker detection, and instant results.')} image={`https://easy-peasy.ai/api/og-template?title=${t(languageObj.name) + ' ' + t('Speech to Text')}`}/>

      <div className='relative bg-white dark:bg-slate-900'>
        <LandingPageNavigation />
        <LanguageSpeechToTextHero languageObj={languageObj}/>
      </div>

      <LogosCloud />

      <div id='how-it-works'>
        <ThreeStepsProcess />
      </div>

      <TranscriptionStats />

      <SupportedFormats />

      <TranscriptionFeaturesSimple />

      <SecurityCompliance />

      <FeaturedLogos />

      <Testimonials />

      <FaqTranscription />

      <CallToAction preset='audios'/>

      <Footer />
    </main>);
};
export default LanguageSpeechToText;
// add static props
async function getStaticProps({ params, }: {
    params: {
        language: string;
    };
}) {
    const language = params.language;
    // Validate if the language exists in our list
    const isValidLanguage = transcriptionLanguages.some((lang) => lang.slug === language.toLowerCase());
    if (!isValidLanguage) {
        return {
            notFound: true,
        };
    }
    return {
        props: {},
        revalidate: 60,
    };
}
// add static paths
export async function getStaticPaths() {
    const locales = [
        'en',
        'ja',
        'es',
        'fr',
        'it',
        'de',
        'ko',
        'zh',
        'th',
        'pt',
        'ar',
    ];
    const paths = transcriptionLanguages.flatMap((language) => locales.map((locale) => ({
        params: {
            language: language.slug,
        },
        locale,
    })));
    return {
        paths,
        fallback: false,
    };
}

    async function __Next_Translate__getStaticProps__1a11b03d35c__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/[language]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d35c__ as getStaticProps }
  